import { render, staticRenderFns } from "./generate-one.vue?vue&type=template&id=bc2c9042&"
import script from "./generate-one.vue?vue&type=script&lang=js&"
export * from "./generate-one.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports